/**
 * Builds the sortBy query parameter value.
 * Converts SDK field names to API field names and normalizes direction.
 */
const buildSort = (sort) => {
    let direction = sort.direction;
    if (direction === "ascending") {
        direction = "asc";
    }
    else if (direction === "descending") {
        direction = "desc";
    }
    let field = sort.field;
    switch (field) {
        case "updatedAt":
            field = "updated_at";
            break;
        case "defaultRetailCpm":
            field = "default_retail_cpm";
            break;
    }
    return `${field} ${direction}`;
};
/**
 * Converts sort configuration to query parameter string.
 */
export const sortToQueryParam = (sort) => {
    if (sort?.field && sort?.direction) {
        return `&sortBy=${buildSort(sort)}`;
    }
    return "";
};
/**
 * Extracts search filter value from where clauses.
 */
const getSearchValue = (wheres) => {
    const searchFilter = wheres?.find((w) => w.field === "search");
    if (searchFilter?.value) {
        const value = Array.isArray(searchFilter.value) ? searchFilter.value[0] : searchFilter.value;
        return typeof value === "string" ? value : undefined;
    }
    return undefined;
};
/**
 * Converts filter where clauses to query parameters.
 */
const wheresToQueryParams = (wheres) => {
    const search = getSearchValue(wheres);
    return search ? `&search=${encodeURIComponent(search)}` : "";
};
/**
 * Builds pagination query params for list endpoints (token-based).
 */
const buildListPagingParams = (paging) => {
    if (!paging?.size)
        return "";
    let params = `&page_size=${paging.size}`;
    if (paging.token) {
        params += `&page_token=${paging.token}`;
        if (paging.offset !== undefined) {
            params += `&offset=${paging.offset}`;
        }
    }
    return params;
};
/**
 * Builds pagination query params for detail endpoints (offset-based).
 */
const buildDetailPagingParams = (paging) => {
    if (!paging)
        return "";
    let params = "";
    if (paging.size) {
        params += `&page_size=${paging.size}`;
    }
    if (typeof paging.offset === "number") {
        params += `&offset=${paging.offset}`;
    }
    return params;
};
/**
 * Converts SDK filters to query parameter string for vertical billing list endpoints.
 */
export const toVerticalBillingQueryParams = (filters = {}, sort) => {
    const params = `${wheresToQueryParams(filters.where)}${buildListPagingParams(filters.paging)}${sortToQueryParam(sort)}`;
    return params.length ? `?${params.substring(1)}` : "";
};
export const toProductPricingQueryParams = (toVerticalBillingQueryParams);
export const toStationGroupPricingQueryParams = (toVerticalBillingQueryParams);
export const toAgencyPricingQueryParams = (toVerticalBillingQueryParams);
export const toAdvertiserPricingQueryParams = (toVerticalBillingQueryParams);
/**
 * Converts filters and sort to query parameter string for detail endpoints.
 * Supports search, offset-based pagination, and sorting for nested data.
 */
export const toDetailQueryParams = (filters = {}, sort) => {
    const params = `${wheresToQueryParams(filters.where)}${buildDetailPagingParams(filters.paging)}${sortToQueryParam(sort)}`;
    return params.length ? `?${params.substring(1)}` : "";
};
export const toProductDetailQueryParams = toDetailQueryParams;
export const toStationGroupDetailQueryParams = toDetailQueryParams;
export const toAgencyDetailQueryParams = toDetailQueryParams;
export const toAdvertiserDetailQueryParams = toDetailQueryParams;
//# sourceMappingURL=filters.js.map